<template>
  <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;">
    <v-layout row v-if="userLogged">
      <v-flex d-flex md6>
        <v-layout v-if="Object.keys(companyDict).length==1" column fill-height style="overflow-y:auto; overflow-x: hidden;">
          <DashboardCard
              v-for="vessel in vesselList"
              @click.native="changeSelected(vessel.name)"
              v-bind:cardData="cardData[vessel.name]"
              v-bind:flat="!showVesselPoints[vessel.name]"
              :key="vessel"
          />
        </v-layout>
        <v-layout v-else column fill-height style="overflow-y:auto; overflow-x: hidden;">
          <v-expansion-panel v-model="panel">
            <v-expansion-panel-content v-for="(value, name) in companyDict" :key="name" lazy>
              <!--Company Card title -->
              <template v-slot:header>
                <div class="title">{{ name }}</div>
              </template>

              <!--Company Card display -->
              <template v-slot:default>
                <v-layout column fill-height style="overflow:auto;background-color:rgb(244,244,244);">
                  <DashboardCard
                      v-for="vessel in value"
                      @click.native="changeSelected(vessel.name)"
                      :key="vessel"
                      v-bind:cardData="cardData[vessel.name]"
                      v-bind:flat="!showVesselPoints[vessel.name]"
                  />
                </v-layout>
              </template>

            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-flex>
      <v-flex d-flex md6 style="padding-top: 0;">
        <Map v-if="mapLoad" v-bind:showDict="showVesselPoints" v-bind:points="mapData" v-bind:zoom="2"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable no-console */

import DashboardCard from '../controls/DashboardCard';
import Map from '../controls/Map';
import {globalStore} from "../main.js";
import {vessels} from "../main.js";

export default {
  name: "Dashboard",
  components: {
    DashboardCard,
    Map
  },
  data: function () {
    return {
      cardData: {},
      mapData: [],
      mapLoad: false,
      email: '',
      password: '',
      show: false,
      alert: false,
      showVesselPoints: {},
      panel: null,
      targetFault: {},
      targetVessel: {},
      redirectOnEvent: false
    }
  },
  created() {
  },
  methods: {
    setDatawDashData() {

      this.cardData = {};

      for (let v = 0; v < this.vesselList.length; v++) {

        let vessel = this.vesselList[v],
            vessDash = globalStore.dashboard[vessel.imo],
            twin = vessel.has_twin;

        var mapping = globalStore.mapping[vessel.imo],
            units = globalStore.units[vessel.imo],
            cardDict = {};

        if (typeof mapping == 'undefined') {
          mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
        }

        if (typeof units == 'undefined') {
          units = globalStore.units[Object.keys(globalStore.units)[0]]
        }

        if (typeof vessDash == 'undefined') {
          continue;
        }

        this.$set(cardDict, 'name', vessel.name);
        this.$set(cardDict, 'imo', vessel.imo);
        this.$set(cardDict, 'twin', twin);
        this.$set(cardDict, 'gas', vessel.is_gas);
        this.$set(cardDict, 'lastUpdate', vessDash.date.slice(0, 10));

        if (twin) {
          try {
            let params = ['LAT', 'LON'];

            for (let p = 0; p < params.length; p++) {
              this.$set(cardDict, params[p], {
                label: mapping['mapping'][params[p]],
                value: this.engineAverage(vessDash['Port'][params[p]], vessDash['Stbd'][params[p]]),
                unit: '',
                format: 4
              });
            }

            params = ['ME_Power_perc', 'ensp', 'STW'];

            for (let p = 0; p < params.length; p++) {
              this.$set(cardDict, params[p], {
                label: mapping['mapping'][params[p]],
                value: this.engineAverage(vessDash['Port'][params[p]], vessDash['Stbd'][params[p]]),
                unit: '[' + units[params[p]] + ']',
                format: 2
              });
            }

            if (cardDict['ME_Power_perc'].value == -1000 && vessDash['load'] != -1000)
              cardDict['ME_Power_perc'].value = this.engineAverage(vessDash['Port']['load'], vessDash['Stbd']['load']) * 100;

            let nvg = true,
                portState = vessDash['Port']['engineStateText'],
                stbdState = vessDash['Stbd']['engineStateText'];

            if (portState == undefined && stbdState == undefined) {
              if (vessDash['Port']['engineState'] == -1000 && vessDash['Stbd']['engineState'] == -1000)
                nvg = false;
            } else {
              if (portState != 'Running' && portState != 'Slowdown' && stbdState != 'Running' && stbdState != 'Slowdown')
                nvg = false;
            }

            this.$set(cardDict, 'engineState', {
              label: 'Engine State',
              value: portState + ' (Port) ' + stbdState + ' (Stbd)',
              unit: '',
              format: null,
              nav: nvg
            });

            this.$set(cardDict, 'faults', {
              label: 'Faults',
              value: vessDash['Port']['Faults'] + ' (Port) ' + vessDash['Stbd']['Faults'] + ' (Stbd)',
              unit: '',
              format: null
            });

            let engines = ['Stbd', 'Port'];

            this.$set(cardDict, 'bsfc', {
              title: mapping['mapping']['bsfc'],
              unit: units['bsfc'],
              value: this.engineAverage(vessDash['Port']['bsfc'][vessDash['Port']['bsfc'].length - 1], vessDash['Stbd']['bsfc'][vessDash['Stbd']['bsfc'].length - 1]),//vessDash['bsfc'][vessDash['bsfc'].length-1],
              format: 1
            });

            this.$set(cardDict.bsfc, 'chartOptions', {
              credits: {enabled: false},
              chart: {backgroundColor: 'transparent'},
              tooltip: {
                formatter: function () {
                  return this.points.reduce(function (s, point) {
                    return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                  }, '');
                },
                shared: true
              },
              legend: {
                enabled: true,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                itemDistance: 5,
                alignColumns: false,
                navigation: {enabled: false}
              },
              title: {text: undefined},
              xAxis: {
                labels: {enabled: false},
                crosshair: true
              },
              yAxis: {
                labels: {enabled: false},
                title: {text: undefined}
              },
              exporting: {
                enabled: false
              },
              series: []
            });

            this.$set(cardDict, 'fcon', {
              title: mapping['mapping']['fcon'],
              unit: units['fcon'],
              value: this.engineAverage(vessDash['Port']['fcon'][vessDash['Port']['fcon'].length - 1], vessDash['Stbd']['fcon'][vessDash['Stbd']['fcon'].length - 1]),
              format: 1
            });

            this.$set(cardDict.fcon, 'chartOptions', {
              credits: {enabled: false},
              chart: {backgroundColor: 'transparent'},
              tooltip: {
                formatter: function () {
                  return this.points.reduce(function (s, point) {
                    return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                  }, '');
                },
                shared: true
              },
              legend: {
                enabled: true,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                itemDistance: 5,
                alignColumns: false,
                navigation: {enabled: false}
              },
              title: {text: undefined},
              xAxis: {
                labels: {enabled: false},
                crosshair: true
              },
              yAxis: {
                labels: {enabled: false},
                title: {text: undefined}
              },
              exporting: {
                enabled: false
              },
              series: []
            });

            this.$set(cardDict, 'sloc', {
              title: 'SLOC setting',
              unit: units['sloc'],
              value: this.engineAverage(vessDash['Port']['sloc'][vessDash['Port']['sloc'].length - 1], vessDash['Stbd']['sloc'][vessDash['Stbd']['sloc'].length - 1]),
              format: 1
            });

            this.$set(cardDict.sloc, 'chartOptions', {
              credits: {enabled: false},
              chart: {backgroundColor: 'transparent'},
              tooltip: {
                formatter: function () {
                  return this.points.reduce(function (s, point) {
                    return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                  }, '');
                },
                shared: true
              },
              legend: {
                enabled: true,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal'
              },
              title: {text: undefined},
              xAxis: {
                labels: {enabled: false},
                crosshair: true
              },
              yAxis: {
                labels: {enabled: false},
                title: {text: undefined}
              },
              exporting: {
                enabled: false
              },
              series: []
            });

            engines.forEach(eng => {
              this.$set(cardDict, eng, {});

              this.$set(cardDict[eng], 'engineColor', vessDash[eng]['eng_KPI_color']);

              let kpi = vessDash[eng]['eng_KPI'] * 100;

              if (kpi.toFixed(1) != '100.0')
                this.$set(cardDict[eng], 'engineKPI', kpi.toFixed(1));
              else
                this.$set(cardDict[eng], 'engineKPI', kpi.toFixed(0));

              let slocSeries = {
                name: eng,
                type: 'line',
                data: [],
                marker: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              };

              for (let i = 0; i < vessDash[eng]['sloc'].length; i++) {
                if (vessDash[eng]['sloc'][i] != -1000)
                  slocSeries.data.push([i, vessDash[eng]['sloc'][i]]);
              }

              cardDict.sloc.chartOptions.series.push(slocSeries);

              let fconSeries = {
                    name: eng,
                    type: 'line',
                    data: [],
                    marker: {
                      enabled: false
                    },
                    states: {
                      hover: {
                        enabled: false
                      },
                      normal: {
                        animation: false
                      },
                      inactive: {
                        opacity: 1
                      }
                    }
                  },
                  fconRef = {
                    name: eng + ' Ref',
                    type: 'line',
                    data: [],
                    marker: {
                      enabled: false
                    },
                    states: {
                      hover: {
                        enabled: false
                      },
                      normal: {
                        animation: false
                      },
                      inactive: {
                        opacity: 1
                      }
                    }
                  };

              for (let i = 0; i < vessDash[eng]['fconRef'].length; i++) {
                if (vessDash[eng]['fcon'][i] != -1000)
                  fconSeries.data.push([i, vessDash[eng]['fcon'][i]]);

                if (vessDash[eng]['fconRef'][i] != -1000)
                  fconRef.data.push([i, vessDash[eng]['fconRef'][i]]);
              }

              cardDict.fcon.chartOptions.series.push(fconSeries);
              cardDict.fcon.chartOptions.series.push(fconRef);

              let bsfcSeries = {
                    name: eng,
                    type: 'line',
                    data: [],
                    marker: {
                      enabled: false
                    },
                    states: {
                      hover: {
                        enabled: false
                      },
                      normal: {
                        animation: false
                      },
                      inactive: {
                        opacity: 1
                      }
                    }
                  },
                  bsfcRef = {
                    name: eng + ' Ref',
                    type: 'line',
                    data: [],
                    marker: {
                      enabled: false
                    },
                    states: {
                      hover: {
                        enabled: false
                      },
                      normal: {
                        animation: false
                      },
                      inactive: {
                        opacity: 1
                      }
                    }
                  };

              for (let i = 0; i < vessDash[eng]['bsfcRef'].length; i++) {
                if (vessDash[eng]['bsfc'][i] != -1000)
                  bsfcSeries.data.push([i, vessDash[eng]['bsfc'][i]]);

                if (vessDash[eng]['bsfcRef'][i] != -1000)
                  bsfcRef.data.push([i, vessDash[eng]['bsfcRef'][i]]);
              }

              cardDict.bsfc.chartOptions.series.push(bsfcSeries);
              cardDict.bsfc.chartOptions.series.push(bsfcRef);
            });

            /**
             * Check if there is a name returned by the server.
             * This name is probably the result of a vessel rename.
             */
            if (globalStore.dashboard[vessel.imo].name) {
              cardDict.name = globalStore.dashboard[vessel.imo].name
            }

            this.$set(this.cardData, vessel.name, cardDict);
          } catch (e) {
          }
        } else {
          let params = ['LAT', 'LON'];

          for (let p = 0; p < params.length; p++) {
            this.$set(cardDict, params[p], {
              label: mapping['mapping'][params[p]],
              value: vessDash[params[p]],
              unit: '',
              format: 4
            });
          }

          params = ['ME_Power_perc', 'ensp', 'STW'];

          for (let p = 0; p < params.length; p++) {
            this.$set(cardDict, params[p], {
              label: mapping['mapping'][params[p]],
              value: vessDash[params[p]],
              unit: '[' + units[params[p]] + ']',
              format: 2
            });
          }

          if ((cardDict['ME_Power_perc'].value == -1000) && (vessDash['load'] != -1000))
            cardDict['ME_Power_perc'].value = vessDash['load'] * 100;

          let nvg = true,
              stateText = vessDash['engineStateText'];

          if (stateText == undefined) {
            if (vessDash['engineState'] == -1000)
              nvg = false;
          } else {
            if ((stateText != 'Running') && (stateText != 'Slowdown'))
              nvg = false;
          }

          this.$set(cardDict, 'engineState', {
            label: 'Engine State',
            value: stateText,
            unit: '',
            format: null,
            nav: nvg
          });

          this.$set(cardDict, 'faults', {
            label: 'Faults',
            value: vessDash['Faults'],
            unit: '',
            format: null
          });

          this.$set(cardDict, 'bsfc', {
            title: mapping['mapping']['bsfc'],
            unit: units['bsfc'],
            value: vessDash['bsfc'][vessDash['bsfc'].length - 1],
            format: 1
          });

          this.$set(cardDict.bsfc, 'chartOptions', {
            credits: {enabled: false},
            chart: {backgroundColor: 'transparent'},
            tooltip: {
              formatter: function () {
                return this.points.reduce(function (s, point) {
                  return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                }, '');
              },
              shared: true
            },
            legend: {
              enabled: true,
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal',
            },
            title: {text: undefined},
            xAxis: {
              labels: {enabled: false},
              crosshair: true
            },
            yAxis: {
              labels: {enabled: false},
              title: {text: undefined}
            },
            exporting: {
              enabled: false
            },
            series: [
              {
                name: 'Values',
                type: 'line',
                data: [],
                marker: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              },
              {
                name: 'Ref',
                type: 'line',
                data: [],
                marker: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              }
            ]
          });

          for (let i = 0; i < vessDash['bsfcRef'].length; i++) {
            if (vessDash['bsfc'][i] != -1000)
              cardDict.bsfc.chartOptions.series[0].data.push([i, vessDash['bsfc'][i]]);

            if (vessDash['bsfcRef'][i] != -1000)
              cardDict.bsfc.chartOptions.series[1].data.push([i, vessDash['bsfcRef'][i]]);
          }

          this.$set(cardDict, 'fcon', {
            title: mapping['mapping']['fcon'],
            unit: units['fcon'],
            value: vessDash['fcon'][vessDash['fcon'].length - 1],
            format: 1
          });

          this.$set(cardDict.fcon, 'chartOptions', {
            credits: {enabled: false},
            chart: {backgroundColor: 'transparent'},
            tooltip: {
              formatter: function () {
                return this.points.reduce(function (s, point) {
                  return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                }, '');
              },
              shared: true
            },
            legend: {
              enabled: true,
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal',
            },
            title: {text: undefined},
            xAxis: {
              labels: {enabled: false},
              crosshair: true
            },
            yAxis: {
              labels: {enabled: false},
              title: {text: undefined}
            },
            exporting: {
              enabled: false
            },
            series: [
              {
                name: 'Values',
                type: 'line',
                data: [],
                marker: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              },
              {
                name: 'Ref',
                type: 'line',
                data: [],
                marker: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              }
            ]
          });

          for (let i = 0; i < vessDash['fconRef'].length; i++) {
            if (vessDash['fcon'][i] != -1000)
              cardDict.fcon.chartOptions.series[0].data.push([i, vessDash['fcon'][i]]);

            if (vessDash['fconRef'][i] != -1000)
              cardDict.fcon.chartOptions.series[1].data.push([i, vessDash['fconRef'][i]]);
          }

          this.$set(cardDict, 'sloc', {
            title: 'SLOC setting',
            unit: units['sloc'],
            value: vessDash['sloc'][vessDash['sloc'].length - 1],
            format: 1
          });

          this.$set(cardDict.sloc, 'chartOptions', {
            credits: {enabled: false},
            chart: {backgroundColor: 'transparent'},
            tooltip: {
              formatter: function () {
                return this.points.reduce(function (s, point) {
                  return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                }, '');
              },
              shared: true
            },
            legend: {
              enabled: true,
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal',
            },
            title: {text: undefined},
            xAxis: {
              labels: {enabled: false},
              crosshair: true
            },
            yAxis: {
              labels: {enabled: false},
              title: {text: undefined}
            },
            exporting: {
              enabled: false
            },
            series: [
              {
                name: 'Values',
                type: 'line',
                data: [],
                marker: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled: false
                  },
                  normal: {
                    animation: false
                  },
                  inactive: {
                    opacity: 1
                  }
                }
              }
            ]
          });

          for (let i = 0; i < vessDash['sloc'].length; i++) {
            if (vessDash['sloc'][i] != -1000)
              cardDict.sloc.chartOptions.series[0].data.push([i, vessDash['sloc'][i]]);
          }

          this.$set(cardDict, 'engineColor', vessDash['eng_KPI_color']);

          let kpi = vessDash['eng_KPI'] * 100;

          if (kpi.toFixed(1) != '100.0')
            this.$set(cardDict, 'engineKPI', kpi.toFixed(1));
          else
            this.$set(cardDict, 'engineKPI', kpi.toFixed(0));

          /**
           * Check if there is a name returned by the server.
           * This name is probably the result of a vessel rename.
           */
          if (globalStore.dashboard[vessel.imo].name) {
            cardDict.name = globalStore.dashboard[vessel.imo].name
          }

          this.$set(this.cardData, vessel.name, cardDict);
        }
      }

      if (this.mapLoad)
        globalStore.loading = false;

      document.body.style.cursor = 'default';
    },
    setMapData() {
      this.mapLoad = false;

      let vessList = Object.values(vessels.vessels);

      if (this.panel != null) {
        let shipCo = Object.keys(this.companyDict)[this.panel];

        vessList = this.companyDict[shipCo];
      }

      this.mapData = [];
      this.showVesselPoints = {};

      for (let v = 0; v < vessList.length; v++) {
        let vessel = vessList[v];

        var mapping = globalStore.mapping[vessel.imo],
            units = globalStore.units[vessel.imo],
            points = [];

        if (typeof mapping == 'undefined') {
          mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
        }

        if (typeof units == 'undefined') {
          units = globalStore.units[Object.keys(globalStore.units)[0]]
        }

        this.showVesselPoints[vessel.name] = false;

        if (Object.keys(globalStore.mapData).includes(vessel.imo)) {
          let dates = Object.keys(globalStore.mapData[vessel.imo]),
              params = ['ME_Power_perc', 'ensp', 'STW'],
              last = true;

          for (let i = dates.length - 1; i >= 0; i--) {
            let currDate = dates[i],
                temp = globalStore.mapData[vessel.imo][currDate],
                html = '<b>' + currDate + ' ' + vessel.name + '</b><br>';

            if (typeof mapping != 'undefined') {
              for (let p = 0; p < params.length; p++) {
                try {
                  if (temp[params[p]] != undefined && temp[params[p]] != -1000)
                    html += mapping['mapping'][params[p]] + ': ' + temp[params[p]].toFixed(2) + ' [' + units[params[p]] + ']<br>';
                  else if ((params[p] == 'ME_Power_perc') && (temp['load'] != -1000))
                    html += mapping['mapping'][params[p]] + ': ' + (temp['load'] * 100).toFixed(2) + ' [' + units[params[p]] + ']<br>';
                  else
                    html += mapping['mapping'][params[p]] + ': - [' + units[params[p]] + ']<br>';
                } catch (e) {
                }
              }
            }

            html += 'Faults: ' + temp['Faults'];

            if (typeof temp['LON'] != 'undefined' && typeof temp['LAT'] != 'undefined') {
              points.push({
                'date': currDate,//.replace(/-/g,''),
                'coords': [temp['LON'], temp['LAT']],
                'color': temp['mapColor'],
                'html': html,
                'status': temp['engineStateText'],
                'vessel': vessel.name,
                'twin': vessel.has_twin,
                'gas': vessel.is_gas,
                'imo': vessel.imo,
                'last': last
              });
            }

            last = false;
          }

          if (points.length > 0) {
            points[0].last = true;
            this.mapData = this.mapData.concat(points);
          }
        }
      }

      this.mapLoad = true;
      globalStore.loading = false;
    },
    average: function (param, count, data, timestamp) {
      let sum = 0;

      for (let i = 1; i <= count; i++) {
        if (data[timestamp][param + i] != -1000)
          sum += data[timestamp][param + i];
        else
          count--;
      }

      if ((sum == 0) || (count == 0))
        return -1000;
      else
        return sum / count;
    },
    engineAverage: function (portVal, stbdVal) {
      let val = 0, count = 0;

      if ((portVal != undefined) && (portVal != -1000)) {
        val += portVal;
        count++;
      }

      if ((stbdVal != undefined) && (stbdVal != -1000)) {
        val += stbdVal;
        count++;
      }
      if (count == 0)
        return -1000;
      else
        return val / count;
    },
    changeSelected(selVessel) {
      this.showVesselPoints = {};

      let vessList = Object.values(vessels.vessels);

      for (let v = 0; v < vessList.length; v++) {
        let vessel = vessList[v];

        if (vessel.name == selVessel)
          this.showVesselPoints[vessel.name] = true;
        else
          this.showVesselPoints[vessel.name] = false;
      }
    }
  },
  computed: {
    dashChanged: function () {
      return globalStore.dashboard;
    },
    mapChanged: function () {
      return globalStore.mapData;
    },
    userLogged: function () {
      return globalStore.userLogged;
    },
    dataLoaded: function () {
      return globalStore.type;
    },
    vesselList: function () {
      var tmpVList = Object.values(vessels.vessels);

      var vList = tmpVList.filter(function (item) {
        return globalStore.availableVessels.includes(item.imo);
      });

      return vList;
    },
    companyDict: function () {
      var dict = {};

      var vesselList = Object.values(vessels.vessels),
          companies = [...new Set(vesselList.map(function (item) {
            return item.company;
          }))];

      companies.sort();

      for (let c = 0; c < companies.length; c++) {
        var vList = vesselList.filter((item) => {
          return item.company == companies[c];
        });

        dict[companies[c]] = vList;
      }

      return dict;
    },
    faults: function () {
      return globalStore.faults;
    },
    loading: function () {
      return globalStore.loading;
    },
    mapping: function () {
      return globalStore.mapping;
    }
  },
  watch: {
    mapChanged: {
      handler: function () {
        this.setMapData();
      },
      deep: true,
      immediate: true
    },
    dashChanged: {
      handler: async function () {
        await this.setDatawDashData();
      },
      deep: true,
      immediate: true
    },
    dataLoaded: function () {
    },
    vesselList: function () {
      this.setDatawDashData();
    },
    panel: function () {
      this.setMapData();
    },
    loading: function () {
    },
    mapping: function () {
      this.setDatawDashData();
    }
  },
  mounted() {
    globalStore.selectedIMO = '';
    globalStore.selectedVessel = '';

    this.setDatawDashData();

    globalStore.MyEvent.listen('vesselDataLoaded', () => {
      if (this.redirectOnEvent) {
        this.redirectOnEvent = false;
        this.$router.push({path: `/vessel-view/${globalStore.selectedVessel}`});
      }
    });
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 300px;
  height: 100px;
  background-color: white;
  /* color: rgb(33,33,33);
  background-color:transparent; */
}

</style>
